<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div v-if="data && data.baseInfo" class="fastRect">
      <div class="title">产品信息<span>请核对信息</span></div>
      <van-field
        v-model="data.baseInfo.companyCnName"
        clearable
        rows="1"
        autosize
        type="textarea"
        label="保险公司"
        readonly
      />
      <van-field
        v-model="data.baseInfo.productName"
        clearable
        rows="1"
        autosize
        type="textarea"
        label="产品名称"
        readonly
      />
      <van-field
        v-model="data.baseInfo.planName"
        clearable
        rows="1"
        autosize
        type="textarea"
        label="计划名称"
        readonly
      />
    </div>

    <div class="fastRect">
      <div class="title">基本信息<span>请填写基本信息</span></div>
      <van-field
        v-model="dateBeginStr"
        clearable
        label="起保日期"
        placeholder="请选择起保日期"
        readonly
        @click="showBeginDate=true"
      />
      <van-field
        v-model="dateEndStr"
        clearable
        label="终保日期"
        readonly
      />
    </div>

    <div v-if="dataApplicantConfig" class="fastRect">
      <div class="title">{{ dataApplicantConfig.name }}<span>{{ dataApplicantConfig.remark }}</span></div>
      <template v-for="(config,index) in dataApplicantConfig.productAttributes">
        <div v-if="config.apiName==='applicantType'" :key="index" class="van-cell van-field">
          <div class="van-cell__title van-field__label"><span>投保人类型</span></div>
          <div>
            <van-radio-group v-model="formData.applicant.applicantType" direction="horizontal" @change="onGetPrice">
              <van-radio v-for="item in config.attributeValues" :key="item.controlValue" :name="item.controlValue" :checked-color="GetColorMainBack()">{{ item.value }}</van-radio>
            </van-radio-group>
          </div>
        </div>
        <van-field
          v-if="config.apiName==='cName'"
          :key="index"
          v-model="formData.applicant[config.apiName]"
          clearable
          :error-message="checkError(formData.applicant[config.apiName],config)"
          :required="config.required===1"
          :label="formData.applicant.applicantType==='0'?'姓名':'机构名称'"
          :placeholder="formData.applicant.applicantType==='0'?'请填写真实姓名，应与投保有效证件一致':'请填写真实机构名称，应与投保有效证件一致'"
        >
          <template #button>
            <van-button size="mini" :color="GetColorMainBack()" type="primary" @click="onCustomerSelect(-1)">常用</van-button>
          </template>
        </van-field>
        <van-field
          v-if="config.type===3 && config.apiName!=='cName'"
          :key="index"
          v-model="formData.applicant[config.apiName]"
          clearable
          :error-message="checkError(formData.applicant[config.apiName],config)"
          :required="config.required===1"
          :label="config.name"
          :placeholder="config.defaultRemind"
          @input="onGetPrice"
        />

        <div v-if="config.apiName==='cardType'" :key="index" class="van-cell van-field">
          <div class="van-cell__title van-field__label"><span>{{ config.name }}</span></div>
          <div>
            <van-radio-group v-if="formData.applicant.applicantType==='0'" v-model="formData.applicant[config.apiName]" direction="horizontal">
              <template v-for="item in config.attributeValues">
                <van-radio
                  v-if="item.controlValue<10 || item.controlValue>=99"
                  :key="item.controlValue"
                  :name="item.controlValue"
                  :checked-color="GetColorMainBack()"
                  @click="onSetRegex(item.regex)"
                >{{ item.value }}</van-radio>
              </template>
            </van-radio-group>
            <van-radio-group v-if="formData.applicant.applicantType==='1'" v-model="formData.applicant[config.apiName]" direction="horizontal">
              <template v-for="item in config.attributeValues">
                <van-radio
                  v-if="item.controlValue>=10 && item.controlValue<99"
                  :key="item.controlValue"
                  :name="item.controlValue"
                  :checked-color="GetColorMainBack()"
                  @click="onSetRegex(item.regex)"
                >{{ item.value }}</van-radio>
              </template>
            </van-radio-group>
          </div>
        </div>

        <div
          v-if="config.apiName==='sex' && ((formData.applicant.cardType>1 && formData.applicant.cardType<=9) || formData.applicant.cardType>=99)"
          :key="index"
          class="van-cell van-field"
        >
          <div class="van-cell__title van-field__label"><span>性别</span></div>
          <div>
            <van-radio-group
              v-model="formData.applicant[config.apiName]"
              direction="horizontal"
            >
              <van-radio v-for="item in config.attributeValues" :key="item.controlValue" :name="item.controlValue" :checked-color="GetColorMainBack()">{{ item.value }}</van-radio>
            </van-radio-group>
          </div>
        </div>

        <van-field
          v-if="config.apiName==='birthday' && ((formData.applicant.cardType>1 && formData.applicant.cardType<=9) || formData.applicant.cardType>=99)"
          :key="index"
          v-model="formData.applicant.birthday"
          clearable
          readonly
          label="出生日期"
          placeholder="请填写出生日期"
          @click="onSelectDate(formData.applicant)"
        />
      </template>
    </div>
    <div v-if="dataInsuredConfig" class="fastRect2">
      <van-collapse v-model="activeUser" accordion>

        <van-collapse-item v-for="(member,index) in formData.insurants" :key="index" :name="index+1">
          <template #title>
            <div class="title"><i v-if="formData.insurants.length>1" class="iconfont iconshanchuround" @click="onRemoveUser(index)" />
              被投保人{{ index+1 }}
              <span v-if="formData.insurants[index].relationId !== '1'">{{ member.cName }}</span>
              <span v-if="formData.insurants[index].relationId === '1'">本人</span></div>
          </template>
          <template v-for="(config,indexConfig) in dataInsuredConfig.productAttributes">
            <div v-if="config.apiName==='relationId'" :key="indexConfig" class="van-cell van-field">
              <div class="van-cell__title van-field__label"><span>{{ config.name }}</span></div>
              <div>
                <van-radio-group v-model="formData.insurants[index][config.apiName]" direction="horizontal" @change="onGetPrice">
                  <template v-for="item in config.attributeValues">
                    <van-radio
                      :key="item.controlValue"
                      :name="item.controlValue"
                      :checked-color="GetColorMainBack()"
                    >{{ item.value }}</van-radio>
                  </template>
                </van-radio-group>
              </div>
            </div>
          </template>
          <template v-for="(config,indexConfig) in dataInsuredConfig.productAttributes">
            <template v-if="formData.applicant.applicantType !== '0' || formData.insurants[index].relationId !== '1'">
              <van-field
                v-if="config.type===3 && config.apiName==='cName'"
                :key="indexConfig"
                v-model="formData.insurants[index][config.apiName]"
                clearable
                :error-message="checkError(formData.insurants[index][config.apiName],config)"
                :required="config.required===1"
                :label="config.name"
                :placeholder="config.defaultRemind"
                @input="onGetPrice"
              >
                <template #button>
                  <van-button size="mini" :color="GetColorMainBack()" type="primary" @click="onCustomerSelect(index)">常用</van-button>
                </template>
              </van-field>

              <van-field
                v-if="config.type===3 && config.apiName!=='cName'"
                :key="indexConfig"
                v-model="formData.insurants[index][config.apiName]"
                clearable
                :error-message="checkError(formData.insurants[index][config.apiName],config)"
                :required="config.required===1"
                :label="config.name"
                :placeholder="config.defaultRemind"
                @input="onGetPrice"
              />

              <div v-if="config.apiName==='cardType'" :key="indexConfig" class="van-cell van-field">
                <div class="van-cell__title van-field__label"><span>{{ config.name }}</span></div>
                <div>
                  <van-radio-group v-model="formData.insurants[index][config.apiName]" direction="horizontal">
                    <template v-for="item in config.attributeValues">
                      <van-radio
                        :key="item.controlValue"
                        :name="item.controlValue"
                        :checked-color="GetColorMainBack()"
                        @click="onSetRegex(item.regex)"
                      >{{ item.value }}</van-radio>
                    </template>
                  </van-radio-group>
                </div>
              </div>
              <div
                v-if="config.apiName==='sex' && ((formData.insurants[index].cardType>1 && formData.insurants[index].cardType<=9) || formData.insurants[index].cardType>=99)"
                :key="indexConfig"
                class="van-cell van-field"
              >
                <div class="van-cell__title van-field__label"><span>性别</span></div>
                <div>
                  <van-radio-group
                    v-model="formData.insurants[index][config.apiName]"
                    direction="horizontal"
                  >
                    <van-radio v-for="item in config.attributeValues" :key="item.controlValue" :name="item.controlValue" :checked-color="GetColorMainBack()">{{ item.value }}</van-radio>
                  </van-radio-group>
                </div>
              </div>

              <van-field
                v-if="config.apiName==='birthday' && formData.insurants[index].cardType!=='1'"
                :key="indexConfig"
                v-model="formData.insurants[index].birthday"
                clearable
                readonly
                label="出生日期"
                placeholder="请填写出生日期"
                @click="onSelectDateIndex(index)"
              /></template>
          </template>
        </van-collapse-item>
      </van-collapse>
      <div v-if="formData.insurants.length<data.attrInfo.maxPeople" class="addNewUser" :style="'color:'+GetColorMainBack()" @click="onAddNewUser">
        <i class="iconfont iconadd" />
        新增被保险人
      </div>
    </div>
    <div v-if="dataBeneficiaryConfig" class="fastRect">
      <div class="title">{{ dataBeneficiaryConfig.name }}</div>
      <van-field
        v-model="data.attrInfo.beneficiaryTypeText"
        readonly=""
        label="受益人"
      />
      <div class="remark">{{ dataBeneficiaryConfig.remark }}</div>
    </div>
    <div v-if="dataOtherConfig" class="fastRect">
      <div class="title">{{ dataOtherConfig.name }}</div>
      <template v-for="(config,index) in dataOtherConfig.productAttributes">
        <div v-if="config.type===0" :key="index" class="van-cell van-field">
          <div class="van-cell__title van-field__label"><span>{{ config.name }}</span></div>
          <div>
            <van-radio-group v-model="formData.otherInfo[config.apiName]" direction="horizontal">
              <van-radio v-for="item in config.attributeValues" :key="item.controlValue" :name="item.controlValue" :checked-color="GetColorMainBack()">{{ item.value }}</van-radio>
            </van-radio-group>
          </div>
        </div>

        <van-field
          v-if="config.type===3"
          :key="index"
          v-model="formData.otherInfo[config.apiName]"
          clearable
          :required="config.required===1"
          :label="config.name"
          :placeholder="config.defaultRemind"
          :error-message="checkError(formData.otherInfo[config.apiName],config)"
        />
        <van-field
          v-if="config.type===8 && config.apiName==='destination'"
          :key="index"
          v-model="formData.otherInfo[config.apiName]"
          readonly
          :required="config.required===1"
          :label="config.name"
          :placeholder="config.defaultRemind"
          @click="onShowDestination"
        />
      </template>

      <div class="remark">{{ dataOtherConfig.remark }}</div>
    </div>

    <div v-if="dataUrgencyConfig" class="fastRect">
      <div class="title">{{ dataUrgencyConfig.name }}<span>{{ dataUrgencyConfig.remark }}</span></div>
      <template v-for="(item,index) in dataUrgencyConfig.productAttributes">
        <van-field
          v-if="item.type===3"
          :key="index"
          v-model="formData[item.apiName]"
          :error-message="checkError(formData[item.apiName],item)"
          :required="item.required===1"
          clearable
          :label="item.name.replace('紧急联系人','')"
          :placeholder="item.defaultRemind"
        />
      </template>
    </div>

    <div class="downEmpty" />
    <div class="downButtonRect">
      <van-row>
        <van-col span="16" class="priceRect">
          <div :style="'color:'+GetColorMainBack()">
            <span>￥</span>{{ ShowMoneySpan(totalPrice*0.01,true) }}.<span>{{ ShowMoneySpan(totalPrice*0.01,false) }}</span>
            <i class="iconfont iconupjt" @click="showPriceMore=true" />
          </div>
        </van-col>
        <van-col span="8"><van-button :loading="buttonLoading" :disabled="buyButtonDisabled" :color="GetColorMainBack()" size="large" style="width:100%;height:3em;line-height:3em" @click="onBuy">立即投保</van-button></van-col>
      </van-row>

    </div>
    <dateSelect v-model="showBeginDate" :default-date="defaultDate" :max-date="maxDate" :min-date="minDate" @onChange="onBeginDateChange" />
    <destinationSelect v-model="destinationSelectCashCode" :default-value="destinationSelectList" @onSelect="onSelectDestination" />
    <van-popup v-model="showDateSelect" position="bottom" get-container="body" @closed="showDateSelect=false">
      <van-datetime-picker
        v-model="dateSelect"
        type="date"
        :min-date="minDateBirthday"
        :max-date="maxDateBirthday"
        @confirm="onBirthdayChange"
        @cancel="showDateSelect=false"
      />
    </van-popup>
    <van-popup v-model="showPriceMore" position="bottom" class="priceDetailedRect" get-container="body" @closed="showPriceMore=false">
      <div class="closeButton">  <i class="iconfont iconclosex" @click="showPriceMore=false" /></div>
      <van-row v-if="data && data.baseInfo" class="topName">
        <van-col span="16">{{ data.baseInfo.companyCnName }}</van-col>
        <van-col span="8" class="rigth"><img :src="data.baseInfo.bigLogo" class="logoImg"></van-col>
      </van-row>
      <div v-if="data && data.baseInfo" class="rect">
        <div class="dataRect">
          <div class="rectTitle">保障权益</div>
          <ul>
            <li v-for="(item,index) in data.baseInfo.protectItems" :key="index">
              <div class="list-nap1">{{ item.name }}</div><div class="list-line" /><div class="list-con1">{{ item.defaultValue }}</div>
            </li>
          </ul>
        </div>

        <van-row class="person">
          <van-col span="12">人数</van-col>
          <van-col span="12" class="rigth">{{ priceDetailedList.length }}人</van-col>
        </van-row>
        <van-row v-for="(item,index) in priceDetailedList" :key="index" class="person">
          <van-col span="12">{{ getPersonName(index) }}</van-col>
          <van-col span="12" class="rigth">CNY {{ ShowMoney(item.singlePrice*0.01,2) }}</van-col>
        </van-row>
      </div>
    </van-popup>
    <customerSelect v-model="showCustomerSelect" @change="onCustomerChange" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Field, RadioGroup, Radio, DatetimePicker, Popup, Collapse, CollapseItem, Dialog } from 'vant'
import TopBar from '@/components/TopBar'
import { getUrlKey, ShowMoneySpan, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import dateSelect from '@/components/dateSelect'
import destinationSelect from '@/views/insurance/destinationSelect'
import customerSelect from '@/components/customerSelect'

export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]: Popup,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Dialog.name]: Dialog,
    TopBar,
    dateSelect,
    customerSelect,
    destinationSelect
  },
  data() {
    return {
      titleTop: '',
      title: '创建保险订单',
      backurl: '/store/index',
      insuranceProductId: undefined,
      paramsType: undefined,
      paramsTypeId: undefined,
      loading: true,
      loadingPrice: false,
      buttonLoading: false,
      data: {

      },
      dataInsurance: undefined,
      dataUrgencyConfig: undefined,
      dataOtherConfig: undefined,
      dataBeneficiaryConfig: undefined,
      dataApplicantConfig: undefined,
      dataInsuredConfig: undefined,
      totalPrice: 0,
      saveTotalPrice: 0,
      maxDay: 1,
      defaultDate: undefined,
      maxDate: undefined,
      minDate: undefined,
      extMap: undefined,
      showBeginDate: false,
      dateBeginStr: '',
      dateEndStr: '',
      formData: {
        dateStart: undefined,
        dateEnd: undefined,
        applicant: {
          applicantType: '0'
        },
        insurants: [{}],
        otherInfo: {}
      },
      selectBirthdayObject: undefined,
      selectBirthdayIndex: undefined,
      showDateSelect: false,
      dateSelect: undefined,
      minDateBirthday: new Date(1900, 0, 1),
      maxDateBirthday: new Date(),
      activeUser: 1,
      destinationSelectCashCode: undefined,
      destinationSelectList: undefined,
      savePriceBirthdyStr: '',
      priceDetailedList: [],
      showPriceMore: false,
      showCustomerSelect: false,
      customerSelectId: -1,
      buyButtonDisabled: false
    }
  },

  created() {
    this.savePriceBirthdyStr = ''
    this.insuranceProductId = this.$route.params.id
    this.paramsType = getUrlKey('type')
    this.paramsTypeId = getUrlKey('typeid')
    var dayStr = getUrlKey('day')
    if (dayStr) {
      this.maxDay = parseInt(dayStr)
    }
    var priceStr = getUrlKey('price')
    if (priceStr) {
      this.totalPrice = parseInt(priceStr)
      this.saveTotalPrice = parseInt(priceStr)
    }
    var extMapStr = getUrlKey('extMap')
    if (extMapStr) {
      this.extMap = JSON.parse(decodeURIComponent(extMapStr))
    } else {
      this.extMap = undefined
    }

    this.titleTop = GetSysTitle()
    this.init(() => {
      this.loadParamsInfo()
    })
  },
  methods: {
    getUrlKey,
    ShowMoneySpan,
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    loadParamsInfo() {
      if (!this.paramsType || !this.paramsTypeId) {
        return
      }
      var data = [
        { type: this.paramsType, id: this.paramsTypeId }
      ]
      request({
        url: '/Insurance/GetInsuranceMemberInfoList',
        method: 'post',
        data: data
      }).then(response => {
        if (!response.success) {
          return
        }
        if (response.data && response.data.length > 0) {
          var app = response.data[0]
          this.formData.applicant.applicantType = '0'
          this.formData.applicant['cName'] = app.cName
          this.formData.applicant['eName'] = app.eName
          this.formData.applicant['cardType'] = app.cardType + ''
          this.formData.applicant['cardCode'] = app.cardNumber
          this.formData.applicant['sex'] = app.sex + ''
          this.formData.applicant['birthday'] = app.birthday
          this.formData.applicant['mobile'] = app.mobile
          this.formData.applicant['email'] = app.email
          this.formData.applicant = JSON.parse(JSON.stringify(this.formData.applicant))
          if (app.startTime) {
            this.onBeginDateChange(app.startTime)
            this.defaultDate = new Date(app.startTime)
          }
          for (var i = 0; i < response.data.length; i++) {
            app = response.data[i]
            if (i === 0) {
              this.formData.insurants[i]['relationId'] = '1'
            }
            this.formData.insurants[i]['cName'] = app.cName
            this.formData.insurants[i]['eName'] = app.eName
            this.formData.insurants[i]['cardType'] = app.cardType + ''
            this.formData.insurants[i]['cardCode'] = app.cardNumber
            this.formData.insurants[i]['sex'] = app.sex + ''
            this.formData.insurants[i]['birthday'] = app.birthday
            this.formData.insurants[i]['mobile'] = app.mobile
            this.formData.insurants[i]['email'] = app.email
          }
          this.formData.insurants = JSON.parse(JSON.stringify(this.formData.insurants))
        }
      })
    },
    init(callback) {
      request({
        url: '/Insurance/GetInsuranceProductAttr',
        method: 'post',
        params: { id: this.insuranceProductId }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.data = response.data
        var dataInsurance = this.data.attrInfo.attrModules.filter(item => item.moduleId === 102)
        if (dataInsurance.length > 0) {
          this.dataInsurance = dataInsurance[0]
        }
        var dataUrgencyConfig = this.data.attrInfo.attrModules.filter(item => item.moduleId === 101)
        if (dataUrgencyConfig.length > 0) {
          this.dataUrgencyConfig = dataUrgencyConfig[0]
        }
        var dataBeneficiaryConfig = this.data.attrInfo.attrModules.filter(item => item.moduleId === 30)
        if (dataBeneficiaryConfig.length > 0) {
          this.dataBeneficiaryConfig = dataBeneficiaryConfig[0]
        }
        var dataApplicantConfig = this.data.attrInfo.attrModules.filter(item => item.moduleId === 10)
        if (dataApplicantConfig.length > 0) {
          this.dataApplicantConfig = dataApplicantConfig[0]
          this.dataApplicantConfig.productAttributes = this.sameList(this.dataApplicantConfig.productAttributes)
        }
        var dataInsuredConfig = this.data.attrInfo.attrModules.filter(item => item.moduleId === 20)
        if (dataInsuredConfig.length > 0) {
          this.dataInsuredConfig = dataInsuredConfig[0]
        }

        switch (this.data.attrInfo.beneficiaryType) {
          case 1:this.data.attrInfo.beneficiaryTypeText = '法定受益人'; break
          case 2:this.data.attrInfo.beneficiaryTypeText = '指定受益人'; break
          case 12:this.data.attrInfo.beneficiaryTypeText = '法定和指定受益人'; break
        }

        this.dataOtherConfig = this.data.attrInfo.attrModules.filter(item => item.moduleId === 40)
        if (this.dataOtherConfig.length > 0) {
          this.dataOtherConfig = this.dataOtherConfig[0]
        }

        // 次日投保，当日投保时限暂未处理
        // deadline	String	当日投保截止时间 格式： 24:00
        // nextDayDeadline	String	次日投保截止时间 格式： 24:00
        this.formData.dateStart = new Date()
        this.formData.dateStart = new Date(this.formData.dateStart.setDate(this.formData.dateStart.getDate() + this.data.attrInfo.firstDate))
        this.formData.dateEnd = new Date()
        this.formData.dateEnd = new Date(this.formData.dateEnd.setDate(this.formData.dateEnd.getDate() + this.data.attrInfo.firstDate + this.maxDay))
        setTimeout(() => {
          this.minDate = new Date()
          this.minDate = new Date(this.minDate.setDate(this.minDate.getDate() + this.data.attrInfo.firstDate))
          this.maxDate = new Date()
          this.maxDate = new Date(this.maxDate.setDate(this.maxDate.getDate() + this.data.attrInfo.latestDate))
          this.dateBeginStr = formatDate(this.formData.dateStart, 'yyyy/MM/dd')
          this.dateEndStr = formatDate(this.formData.dateEnd, 'yyyy/MM/dd')
        }, 1)

        this.loading = false
        if (callback) {
          callback()
        }
      })
    },
    // 数组排重
    sameList(list) {
      list.forEach(item => {
        if (item.attributeValues) {
          var attr = []
          item.attributeValues.forEach(el => {
            var find = attr.filter(elf => elf.controlValue === el.controlValue).length > 0
            if (!find) {
              attr.push(el)
            }
          })
          item.attributeValues = attr
        }
      })
      return list
    },
    onBeginDateChange(date) {
      this.formData.dateStart = new Date(date)
      this.formData.dateEnd = new Date(date)
      this.formData.dateEnd = new Date(this.formData.dateEnd.setDate(this.formData.dateEnd.getDate() + this.maxDay))
      this.dateBeginStr = formatDate(date, 'yyyy/MM/dd')
      this.dateEndStr = formatDate(this.formData.dateEnd, 'yyyy/MM/dd')
    },
    checkError(value, item, regexStr, errorRemind) {
      if (item.required === 0 && !value) {
        return ''
      }
      if (!item.regex) {
        return ''
      }
      // if (item.regex.indexOf('$|^') > 0) {
      //   console.log('处理钱:' + item.regex)
      //   item.regex = item.regex.split('$|^')[0] + '$'
      //   console.log('处理后:' + item.regex)
      // }
      // eslint-disable-next-line no-eval
      // console.log('处理钱:' + item.regex)
      // console.log('处理后:' + '/' + item.regex + '/')

      // eslint-disable-next-line no-eval
      var regex = eval('/' + item.regex + '/')

      return regex.test(value) ? '' : item.errorRemind
    },
    onBuy() {
      var formData = JSON.parse(JSON.stringify(this.formData))
      formData.dateStart = formatDate(this.formData.dateStart, 'yyyy/MM/dd')
      formData.dateEnd = formatDate(this.formData.dateEnd, 'yyyy/MM/dd')
      formData.otherInfo.extMap = this.extMap
      formData.insuranceProductId = this.insuranceProductId
      console.log('onBuy', formData)
      console.log('priceDetailedList', this.priceDetailedList)

      var i = 0
      this.buyButtonDisabled = !(this.priceDetailedList && this.priceDetailedList.length > 0)
      if (!this.buyButtonDisabled) {
        formData.insurants.forEach(item => {
          item.singlePrice = this.priceDetailedList[i++].singlePrice
        })
      }
      this.buttonLoading = true
      request({
        url: '/Insurance/CreateInsure',
        method: 'post',
        data: formData
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        this.$router.push('/insurance/myInfo/' + response.data.insuranceOrderId + '?jumpurl=' + encodeURIComponent(response.data.cpsInsureUrl))
      })
    },
    onSetRegex(regex) {
      // console.log('onSetRegex', regex)
      var item = this.dataApplicantConfig.productAttributes.filter(el => el.apiName === 'cardCode')
      // console.log('onSetRegex item', item)
      if (item.length > 0) {
        item[0].regex = regex
      } else {
        item[0].regex = undefined
      }
    },
    onSelectDate(object) {
      if (object.birthday) {
        this.dateSelect = new Date(object.birthday)
      } else {
        this.dateSelect = new Date(2000, 5, 15)
      }
      this.selectBirthdayObject = object
      this.selectBirthdayIndex = undefined
      this.showDateSelect = true
    },
    onSelectDateIndex(index) {
      if (this.formData.insurants[index].birthday) {
        this.dateSelect = new Date(this.formData.insurants[index].birthday)
      } else {
        this.dateSelect = new Date(2000, 5, 15)
      }
      this.selectBirthdayObject = undefined
      this.selectBirthdayIndex = index
      this.showDateSelect = true
    },
    onBirthdayChange(date) {
      if (this.selectBirthdayObject) {
        this.selectBirthdayObject.birthday = formatDate(date, 'yyyy/MM/dd')
      } else {
        this.formData.insurants[this.selectBirthdayIndex].birthday = formatDate(date, 'yyyy/MM/dd')
      }
      this.showDateSelect = false
      this.onGetPrice()
    },
    onAddNewUser() {
      this.formData.insurants.push({})
      this.activeUser = this.formData.insurants.length
      this.onGetPrice()
    },
    onRemoveUser(index) {
      Dialog.confirm({
        title: '删除保险人',
        message: '是否确认删除当前保险人?'
      })
        .then(() => {
          this.formData.insurants.splice(index, 1)
          this.onGetPrice()
        })
    },
    onShowDestination() {
      this.destinationSelectList = undefined
      this.destinationSelectList = this.formData.applicant['destination']
      this.destinationSelectCashCode = this.data.insuranceProduct.insuranceProductId
    },
    onSelectDestination(listStr) {
      console.log('onSelectDestination', listStr)
      this.formData.applicant['destination'] = listStr
      this.formData.otherInfo['destination'] = listStr
    },
    // 获取参保人员姓名
    getPersonName(index) {
      if (this.formData.insurants.length <= index) {
        return ''
      }
      var insurant = this.formData.insurants[index]
      var name
      if (insurant.relationId === '1') {
        name = this.formData.applicant.cName ? this.formData.applicant.cName : this.formData.applicant.eName
      } else {
        name = insurant.cName ? insurant.cName : insurant.eName
      }
      if (name && name !== '') {
        return name
      }
      return '被投保人' + (index + 1)
    },
    // 获取保费集合
    onGetPrice() {
      var birthdaySty = ''
      var postData = {
        insuranceProductId: this.data.insuranceProduct.insuranceProductId,
        day: this.maxDay,
        extMap: this.extMap,
        list: []
      }
      // console.log('计算保费onGetPrice', postData)
      var id = 0
      this.formData.insurants.forEach(item => {
        console.log('item', item)
        var birthday = ''
        var cardCode = ''
        var cardType = '0'
        if (item.relationId === '1' && this.formData.applicant.applicantType === '0') {
          birthday = this.formData.applicant.birthday
          cardCode = this.formData.applicant.cardCode
          cardType = this.formData.applicant.cardType
        } else {
          birthday = item.birthday
          cardCode = item.cardCode
          cardType = item.cardType
        }
        if (birthday || cardCode) {
          console.log('birthday', birthday)
          console.log('cardCode', cardCode)
          console.log('cardType', cardType)
          if (cardType === '1') {
            postData.list.push({
              id: id,
              idCard: cardCode
            })
            birthdaySty += id + cardCode
          } else {
            postData.list.push({
              id: id,
              birthday: birthday
            })
            birthdaySty += id + birthday
          }
        }
        id++
      })
      // 如果关键信息未发生改变则不重新计算
      if (birthdaySty === this.savePriceBirthdyStr) {
        return
      }
      this.savePriceBirthdyStr = birthdaySty
      this.loadingPrice = true
      this.priceDetailedList = []
      request({
        url: '/Insurance/GetSimpleTrialList',
        method: 'post',
        data: postData
      }).then(response => {
        this.loadingPrice = false
        if (!response.success) {
          return
        }
        this.priceDetailedList = response.data
        var price = 0
        this.buyButtonDisabled = !(response.data && response.data.length > 0)
        response.data.forEach(item => {
          price += item.singlePrice
        })
        if (price === 0) {
          this.totalPrice = this.saveTotalPrice
        } else {
          this.totalPrice = price
        }
      })
    },
    onCustomerSelect(index) {
      console.log('onCustomerSelect', index)
      this.customerSelectId = index
      this.showCustomerSelect = true
    },
    onCustomerChange(data) {
      console.log('onCustomerChange', data)
      console.log('onCustomerChangeIndex', this.customerSelectId)
      if (!data) {
        return
      }
      if (this.customerSelectId < 0) {
        this.formData.applicant['cName'] = data.loaclName
        this.formData.applicant['eName'] = data.lastName + ' ' + data.firstName
        if (data.idCardNumber) {
          this.formData.applicant['cardType'] = '1'
          this.formData.applicant['cardCode'] = data.idCardNumber
        } else if (data.passportNumber) {
          this.formData.applicant['cardType'] = '2'
          this.formData.applicant['cardCode'] = data.passportNumber
        }
        switch (data.sex) {
          case 'MALE':this.formData.applicant['sex'] = '1'
            break
          case 'FEMALE':this.formData.applicant['sex'] = '0'
            break
          default:this.formData.applicant['sex'] = undefined
            break
        }
        this.formData.applicant['birthday'] = formatDate(data.birthday, 'yyyy/MM/dd')
        this.formData.applicant['mobile'] = data.phone
        this.formData.applicant['email'] = data.email
        this.formData.applicant = JSON.parse(JSON.stringify(this.formData.applicant))
      } else {
        this.formData.insurants[this.customerSelectId]['cName'] = data.loaclName
        this.formData.insurants[this.customerSelectId]['eName'] = data.lastName + ' ' + data.firstName
        if (data.idCardNumber) {
          this.formData.insurants[this.customerSelectId]['cardType'] = '1'
          this.formData.insurants[this.customerSelectId]['cardCode'] = data.idCardNumber
        } else if (data.passportNumber) {
          this.formData.insurants[this.customerSelectId]['cardType'] = '2'
          this.formData.insurants[this.customerSelectId]['cardCode'] = data.passportNumber
        }
        switch (data.sex) {
          case 'MALE':this.formData.insurants[this.customerSelectId]['sex'] = '1'
            break
          case 'FEMALE':this.formData.insurants[this.customerSelectId]['sex'] = '0'
            break
          default:this.formData.insurants[this.customerSelectId]['sex'] = undefined
            break
        }
        this.formData.insurants[this.customerSelectId]['birthday'] = formatDate(data.birthday, 'yyyy/MM/dd')
        this.formData.insurants[this.customerSelectId]['mobile'] = data.phone
        this.formData.insurants[this.customerSelectId]['email'] = data.email
        this.formData.insurants = JSON.parse(JSON.stringify(this.formData.insurants))
      }
      this.onGetPrice()
    }
  }
}
</script>
<style>
.fastRect2 .van-collapse-item__content{
  padding: 0.5em;
}
</style>
<style scoped>
.fullRect{
  height: calc(100vh - 3em);
  overflow-y: scroll;
}
.fastRect2{
    background-color: #fff;
    border-radius: 0.3em;
    margin:0 1em;
    overflow: hidden;
}
.fastRect2 .title{
    font-size: 1.3em;
    font-weight: 700;
    padding: 0.3em 0 0.3em 0.4em;
}
.fastRect2 .title i{
  margin-right: 0.5em;
}
.fastRect2 .title span{
  font-size: 0.7em;
  color: #999;
  padding-left: 0.4em;
  font-weight: 400;
}
.fastRect2 .addNewUser{
  text-align: center;
  padding: 1em 0;

}
.fastRect{
    background-color: #fff;
    border-radius: 0.3em;
    padding: 0.5em;
    margin: 1em;
}
.fastRect .title{
    font-size: 1.1em;
    font-weight: 700;
    padding: 0.3em 0 0.3em 0.9em;
}
.fastRect .title span{
  font-size: 0.7em;
  color: #999;
  padding-left: 0.4em;
  font-weight: 400;
}

.fastRect .remark{
  font-size: 0.7em;
  color: #999;
  padding: 0.5em 1em;
}

.downEmpty{
  height: 3em;
}
.downButtonRect {
  height: 3em;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  border-top: 1px solid #f5f5f5;
}
.downButtonRect .priceRect{
  line-height: 3em;
  padding-left: 1em;
}
.downButtonRect .priceRect div{
  font-size: 1.7em;
}
.downButtonRect .priceRect div span{
  font-size: 0.7em;
}
.downButtonRect .priceRect i{
  margin-left: 0.5em;
  color: #999;
}

.priceDetailedRect{
}
.priceDetailedRect .closeButton{
  text-align: right;
  padding: 0.5em 1em;
}
.priceDetailedRect .topName{
  padding: 0 1em;
  font-weight: 700;
  line-height: 2em;
  border-bottom:1px solid #f5f5f5;
}
.priceDetailedRect .logoImg{
  height: 2em;
}
.priceDetailedRect .rect{
  padding: 1em;
  overflow-y: scroll;
  min-height: 30vh;
  max-height: 60vh;
}
.priceDetailedRect .rect .person{
  font-size: 0.9em;
  font-weight: 700;
  line-height:  2em;
}
.priceDetailedRect .dataRect{
  padding: 0.5em 0;
  border-bottom:1px solid #f5f5f5;
}
.priceDetailedRect .dataRect .rectTitle{
  font-size: 0.9em;
  font-weight: 700;
  padding-bottom: 0.5em;
}
.priceDetailedRect .dataRect ul li{
  position: relative;
  overflow: hidden;
}
.priceDetailedRect .dataRect ul li div{
  display:inline-block;
  font-size: 0.8em;
  line-height: 1.8em;

}
.priceDetailedRect .dataRect .list-nap1{
  overflow:hidden;
  white-space:nowrap;
  text-overflow:ellipsis;
  max-width: 50vw;
  margin-left: 1em;
  color: #999;
}
.priceDetailedRect .dataRect .list-line{
  border-top:1px dashed #d8d8d8;
  position:absolute;
  top:0.9em;
  margin: 0 1em;
  width: 75%;
}
.priceDetailedRect .dataRect .list-con1{
  position: absolute;
  right: -1em;
  padding: 0 1em;
  z-index: 1;
  text-align: right;
  background: #fff;
}
</style>
